import React from 'react';
import styles from '../../styles/Footer.module.scss';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import LOGO from '../../images/logo.webp';

const normalizeSocialUrl = (value, fallback) => {
  const trimmed = String(value || '').trim();
  if (!trimmed) return fallback;
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) return trimmed;
  return `https://${trimmed.replace(/^@/, '')}`;
};

const Footer = () => {
  const contacts = useSelector((state) => state.contacts.data);
  const instagramUrl = normalizeSocialUrl(contacts?.instagram, 'https://instagram.com');
  const facebookUrl = normalizeSocialUrl(contacts?.facebook, 'https://facebook.com');
  const youtubeUrl = normalizeSocialUrl(contacts?.youtube, 'https://youtube.com');

  return (
    <footer className={styles.footer}>
     <div className={styles.logo}>
        <Link to='/'>
          <img src={LOGO} alt="ARKDetali — гальмівні системи" width={140} height={42} decoding="async" />
          <div className={styles.logoText}>
          <p className={styles.brandName}>ARKDetali</p>
          <span>Brake Systems</span>
          </div>
        </Link>
      </div>
      <div className={styles.rights}>
        <Link to="/delivery">Доставка</Link>
        {' · '}
        <Link to="/payment">Оплата</Link>
        {' · '}
        ARKDetali-2018
      </div>
      <div className={styles.socials}>
      <a href={instagramUrl} target="_blank" rel="noreferrer" aria-label="Instagram ARKDetali">
        <svg className="icon" aria-hidden="true">
          <use xlinkHref={`${process.env.PUBLIC_URL}/sprite.svg#instagram`} />
        </svg>
      </a>

      <a href={facebookUrl} target="_blank" rel="noreferrer" aria-label="Facebook ARKDetali">
        <svg className="icon" aria-hidden="true">
          <use xlinkHref={`${process.env.PUBLIC_URL}/sprite.svg#facebook`} />
        </svg>
      </a>

      <a href={youtubeUrl} target="_blank" rel="noreferrer" aria-label="YouTube ARKDetali">
        <svg className="icon" aria-hidden="true">
          <use xlinkHref={`${process.env.PUBLIC_URL}/sprite.svg#youtube`} />
        </svg>
      </a>
    </div>
    </footer>
  )
}

export default Footer
